/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap-v5'
import { IOrderProduct } from '../../models/OrderModel'
import { removeTrailingZeros, Toast } from '../../modules/common/helper'

type Props = {
    show: boolean
    mode: string
    data?: any
    qrType?: string
    onClose: () => void
    handleAddTocart: (data: IOrderProduct, qty: number) => void
}

const QuantityModal: React.FC<Props> = ({ show, data, qrType, onClose, handleAddTocart }) => {
    const warehouseQty = data?.inventory_of_supplier?.warehouse?.quantity ?? 0;
    const [qty, setQty] = useState(data?.qty || 1);
    const handlechangeQty = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value > warehouseQty && qrType === 'order') {
            Toast.fire({
                icon: 'warning',
                title: 'Số lượng đặt lớn hơn số lượng tồn kho!',
            })
        }
        setQty(parseInt(e.target.value))
    }
    const qtyClass= warehouseQty <= 0 ? 'text-danger' : 'text-primary';
    return (
        <Modal
            show={show}
            onHide={onClose}
            aria-labelledby='contained-modal-title-vcenter'
            backdrop='static'
            keyboard={false}
            centered
        >
            <Modal.Header className='d-flex'>
                <Modal.Title>Sản phẩm: {data?.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-10">
            <form>
                <div className="col-12 mb-3">
                    <label className={qtyClass}>Tồn kho: { removeTrailingZeros(warehouseQty) }</label>
                </div>
                <div className="col-12">
                    <label>Nhập số lượng</label>
                    <input type='number' value={qty} className='form-control' onChange={handlechangeQty}/>
                </div>
                <div className='d-flex mb-4 justify-content-center pt-8'>
                    <button className="btn btn-bg-primary me-2" type="button" onClick={() => handleAddTocart(data, qty)}>Lưu</button>
                    <button className="btn btn-bg-secondary" type="button" onClick={() => onClose()}>Tắt</button>
                </div>
            </form>
            </Modal.Body>
        </Modal>
    )
}

export default QuantityModal
